module.exports = __webpack_public_path__ + "img/meet-kristen-top.1da849b5.jpg";